<div class="toast-container" aria-live="polite" aria-label="Notifications">

  @for (toast of toastService.toasts(); track toast.id) {

    <div
      class="toast toast--{{ toast.type }}"
      [class.toast--leaving]="toast.leaving"
      role="alert"
    >
      <!-- Icon -->
      <div class="toast__icon">
        <span class="material-symbols-outlined">{{ iconFor(toast.type) }}</span>
      </div>

      <!-- Body -->
      <div class="toast__body">
        @if (toast.title) {
          <p class="toast__title">{{ toast.title }}</p>
        }
        <p class="toast__message">{{ toast.message }}</p>
      </div>

      <!-- Close button -->
      <button
        class="toast__close"
        (click)="toastService.dismiss(toast.id)"
        aria-label="Dismiss notification"
      >
        <span class="material-symbols-outlined">close</span>
      </button>

      <!-- Progress bar (counts down for the full duration) -->
      <div
        class="toast__progress"
        [style.animation-duration]="toast.duration + 'ms'"
      ></div>

    </div>

  }

</div>
